import {
  GET_ADMINS,
  GET_ADMINS_ERROR,
  ADMINS_LOADING,
  SAVE_ADMIN,
  DELETE_ADMIN,
  SAVE_ROLE,
  DELETE_ROLE,
} from "../actions/types";

const initialState = {
  admins: [],
  // { role, name, access, locked } for each role an admin can be given, full
  // first; locked cannot be edited or removed
  roles: [],
  // Every key a role can be given
  keys: [],
  loading: true,
};

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_ADMINS:
      return {
        ...state,
        loading: false,
        admins: payload.admins,
        roles: payload.roles,
        keys: payload.keys,
      };
    case GET_ADMINS_ERROR:
      return {
        ...state,
        loading: false,
      };
    case ADMINS_LOADING:
      return {
        ...state,
        loading: true,
      };
    case SAVE_ADMIN: {
      const known = state.admins.some((item) => item._id === payload._id);
      return {
        ...state,
        admins: known
          ? state.admins.map((item) => (item._id === payload._id ? payload : item))
          : [...state.admins, payload],
      };
    }
    case DELETE_ADMIN:
      return {
        ...state,
        admins: state.admins.filter((item) => item._id !== payload),
      };
    case SAVE_ROLE: {
      const known = state.roles.some((item) => item.role === payload.role);
      return {
        ...state,
        roles: known
          ? state.roles.map((item) => (item.role === payload.role ? payload : item))
          : [...state.roles, payload],
      };
    }
    case DELETE_ROLE:
      return {
        ...state,
        roles: state.roles.filter((item) => item.role !== payload),
      };
    default:
      return state;
  }
}
